import { render, staticRenderFns } from "./AdminButton.vue?vue&type=template&id=6fa86b9f&scoped=true&"
var script = {}
import style0 from "./AdminButton.vue?vue&type=style&index=0&id=6fa86b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa86b9f",
  null
  
)

export default component.exports